// extracted by mini-css-extract-plugin
module.exports = {"section":"agri_interaction_desktop_section-module--section--2OUdg"};